import omniProductService from './reducers';

import * as omniProductServiceOperations from './operations';
import * as omniProductServiceTypes from './types';

export { omniProductServiceOperations, omniProductServiceTypes };

export default omniProductService;
